import { render, staticRenderFns } from "./dropdown-menu.vue?vue&type=template&id=7dedab8f&scoped=true&lang=pug&"
import script from "./dropdown-menu.vue?vue&type=script&lang=coffee&"
export * from "./dropdown-menu.vue?vue&type=script&lang=coffee&"
import style0 from "./dropdown-menu.vue?vue&type=style&index=0&id=7dedab8f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dedab8f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AccessibilityBtn: require('/opt/build/repo/library/components/globals/accessibility-btn.vue').default})
